import script from "./list-dynamic-config-table.vue?vue&type=script&setup=true&lang=js"
export * from "./list-dynamic-config-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__